export default "__VITE_ASSET__CZX6uMPB__"